import {Component, ViewChild} from "@angular/core";
import {NavController, Slides} from 'ionic-angular';
import {QuestionsPage} from '../questions/questions';


@Component({
  templateUrl: 'build/pages/how-to/how-to.html'
})
export class HowToPage {
  constructor(private nav: NavController) {
    this.nav = nav;


  }

  goForward() {
  var index = this.slider.getActiveIndex() + 1;
  this.slider.slideTo(index, 500);
  }

  goBack() {
  var index = this.slider.getActiveIndex() - 1;
  this.slider.slideTo(index, 500);
  }


  nextPage(){
    this.nav.setRoot(QuestionsPage, {}, {animate: true, direction: 'forward'});
  }

  SliderOptions = {
    pager: true
  }


  @ViewChild('mySlider') slider: Slides;


}
